export default __webpack_public_path__ + "static/media/IMG_0023_4_11zon.883ff219.jpg";